/**
 * Business profile — fields that appear on every tax invoice / receipt.
 *
 * Hard-coded for v1. In Phase 4 (admin dashboard) these become
 * editable in `/admin/settings/business-profile` and stored in a
 * `settings` table.
 *
 * SARS-compliant tax-invoice requirements:
 *   - Supplier legal name
 *   - Supplier physical address
 *   - Supplier VAT registration number (when registered)
 *   - VAT rate disclosed
 *
 * Owner: update the values below or, when Phase 4 ships, edit them
 * in admin settings.
 */

export interface BusinessProfile {
  legalName: string;
  tradingName?: string;          // optional — what the customer recognises
  addressLine1: string;
  addressLine2?: string;
  city: string;
  postalCode?: string;
  country: string;
  vatNumber?: string;            // e.g. "4750123456" — omit until registered
  phone?: string;
  email?: string;
  /** Tax invoice numbering prefix — e.g. "HL/2026/" */
  invoiceNumberPrefix?: string;
}

export const BUSINESS_PROFILE: BusinessProfile = {
  legalName: 'Habby & Lace (Pty) Ltd',
  tradingName: 'HL Coffee Shop',
  addressLine1: 'Habby & Lace Store',
  city: 'Johannesburg',
  country: 'South Africa',
  vatNumber: undefined,           // ← FILL IN when VAT-registered
  email: 'hello@habbyandlace.co.za',
  invoiceNumberPrefix: 'HL/',
};
